// Hoverintent
!function(e,t){if("function"==typeof define&&define.amd)define("hoverintent",["module"],t);else if("undefined"!=typeof exports)t(module);else{var n={exports:{}};t(n),e.hoverintent=n.exports}}(this,function(e){"use strict";var t=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e};e.exports=function(e,n,o){function i(e,t){return y&&(y=clearTimeout(y)),b=0,p?void 0:o?.call(e,t)}function r(e){m=e.clientX,d=e.clientY}function u(e,t){if(y&&(y=clearTimeout(y)),Math.abs(h-m)+Math.abs(E-d)<x.sensitivity)return b=1,p?void 0:n.call(e,t);h=m,E=d,y=setTimeout(function(){u(e,t)},x.interval)}function s(t){return L=!0,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1!==b&&(h=t.clientX,E=t.clientY,e.addEventListener("mousemove",r,!1),y=setTimeout(function(){u(e,t)},x.interval)),this}function c(t){return L=!1,y&&(y=clearTimeout(y)),e.removeEventListener("mousemove",r,!1),1===b&&(y=setTimeout(function(){i(e,t)},x.timeout)),this}function v(t){L||(p=!0,n.call(e,t))}function a(t){!L&&p&&(p=!1,o?.call(e,t))}function f(){e.addEventListener("focus",v,!1),e.addEventListener("blur",a,!1)}function l(){e.removeEventListener("focus",v,!1),e.removeEventListener("blur",a,!1)}var m,d,h,E,L=!1,p=!1,T={},b=0,y=0,x={sensitivity:7,interval:100,timeout:0,handleFocus:!1};return T.options=function(e){var n=e.handleFocus!==x.handleFocus;return x=t({},x,e),n&&(x.handleFocus?f():l()),T},T.remove=function(){e&&(e.removeEventListener("mouseover",s,!1),e.removeEventListener("mouseout",c,!1),l())},e&&(e.addEventListener("mouseover",s,!1),e.addEventListener("mouseout",c,!1)),T}});

class HeaderMenu extends HTMLElement {

  constructor() {
    super();
    this.mq = window.matchMedia('(hover: none)');
    this.selectors = {
      megaMenus: '.js-mega-menu',
      level2Links: '.js-mega-menu-level-2-link',
      lowerLists: '.js-mega-menu-lower-list',
      header: '#shopify-section-stmt-header'
    };
    this.classes = {
      active: 'is-active',
      overlay: 'mega-menu__overlay'
    };
    this.body = document.querySelector('body');
    this.header = document.querySelector(this.selectors.header);
    this.megaMenus = this.querySelectorAll(this.selectors.megaMenus);
    this.level2Links = this.querySelectorAll(this.selectors.level2Links);
    this.lowerLists = this.querySelectorAll(this.selectors.lowerLists);
    this.listeners();
  }

  listeners() {
    if (this.mq.matches) {
      this.touchBindings();
    } else {
      this.hoverIntent();
    }

    this.level2Links.forEach((level2Link) => {
      if (level2Link.href.endsWith('#')) {
        level2Link.addEventListener('click', (e) => {
          e.preventDefault();
        })
      }
    });
  }
  
  otherElements(elements, target) {
    return elements.filter(element => element !== target);
  }

  checkMegaMenu(megaMenu) {
    return megaMenu.contains(megaMenu.querySelector('.mega-menu__content'))
  }

  hideMegaMenus() {
    this.megaMenus.forEach((el) => {
      el.classList.remove(this.classes.active);
    });
  }

  hideSubMenus() {
    [...this.level2Links, ...this.lowerLists].forEach((el) => {
      el.classList.remove(this.classes.active);
    })
  }

  showMegaMenu(megaMenu) {
    const otherMegaMenus = this.otherElements([...this.megaMenus], megaMenu);
  
    otherMegaMenus.forEach((otherMegaMenu) => { 
      otherMegaMenu.classList.remove(this.classes.active);

      otherMegaMenu.querySelectorAll(this.selectors.level2Links, this.selectors.lowerLists).forEach((el) => {
        el.classList.remove(this.classes.active);
      })
    });

    if (!megaMenu.classList.contains(this.classes.active)) {
      this.hideSubMenus();
      megaMenu.classList.add(this.classes.active);

      if (!this.header) return;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
    }
  }

  checkLevel2Link(level2Link) {
    return level2Link.getAttribute('data-has-child-links');
  }

  showLowerList(level2Link) {
    const linkHandle = level2Link.getAttribute('data-link-handle');
    const otherLevel2Links = this.otherElements([...this.level2Links], level2Link);

    otherLevel2Links.forEach((otherLevel2Link) => {
      otherLevel2Link.classList.remove(this.classes.active);
    });

    level2Link.classList.add(this.classes.active);

    this.lowerLists.forEach((lowerList) => {
      const childLink = lowerList.getAttribute('data-child-link');

      lowerList.classList.remove(this.classes.active);

      if (childLink === linkHandle) {
        lowerList.classList.add(this.classes.active);
      }
    });
  }

  hoverIntent() {
    const opts = {
      timeout: 350, 
      interval: 100,
      sensitivity: 7, 
      handleFocus: false 
    };

    this.megaMenus.forEach((megaMenu) => {
      if (!this.checkMegaMenu(megaMenu)) return;

      hoverintent(megaMenu,
        () => {
          this.showMegaMenu(megaMenu);
        }, () => {
          megaMenu.classList.remove(this.classes.active);
        }).options(opts);   
    });

    this.level2Links.forEach((level2Link) => {
      if (!this.checkLevel2Link(level2Link)) return;

      hoverintent(level2Link,
        () => {
          this.showLowerList(level2Link);
        }).options(opts);
    });
  }

  touchBindings() {
    this.megaMenus.forEach(megaMenu => {
      
      if (!this.checkMegaMenu(megaMenu)) return;

      megaMenu.addEventListener('touchstart', () => { 
        this.showMegaMenu(megaMenu);
      })
    });

    this.level2Links.forEach((level2Link) => {

      if (!this.checkLevel2Link(level2Link)) return;

      level2Link.addEventListener('touchstart', (e) => {
        e.preventDefault();
        this.showLowerList(level2Link);
      });
    });

    this.body.addEventListener('touchstart', (e) => {
      if (!this.contains(e.target) || e.target.classList.contains(this.classes.overlay)) this.hideMegaMenus();
    });
  }
}

customElements.define('header-menu', HeaderMenu);